// extracted by mini-css-extract-plugin
export default {"setStatus":"SetStatus_setStatus__DPQ41"};